// extracted by mini-css-extract-plugin
module.exports = {"container":"notification_container__2kglG","icon":"notification_icon__2awGW","button":"notification_button__2u_Qy"};